import { Path } from "react-native-svg";
import { createIcon } from "../Icon";

export const ChargeFastV2SquareIcon = createIcon({
	viewBox: "0 0 24 24",
	path: (
		<>
			<Path
				d="M24 3.1647V20.8348C24 22.5831 22.5826 24 20.8348 24H3.16516C1.41691 24 0 22.5831 0 20.8348V3.1647C0 1.41691 1.41691 0 3.16516 0H20.8348C22.5826 0 24 1.41691 24 3.1647Z"
				stroke="transparent"
			/>
			<Path
				d="M11.965 19.5791C11.159 19.0826 12.1773 16.4442 12.4748 14.6502C12.6483 13.604 10.4053 14.2859 9.77097 14.0891C8.2877 13.6291 9.81673 11.0296 12.575 8.14366C15.3338 5.25768 16.7315 4.25861 17.7099 4.59133C18.688 4.9245 17.5342 8.03932 17.1068 10.2594C16.8949 11.3582 19.3072 10.5926 19.9186 10.8699C20.8151 11.2768 20.7529 12.3848 17.2674 16.138C13.7819 19.8913 12.5686 19.9508 11.9654 19.5791"
				fill="white"
				stroke="transparent"
			/>
			<Path
				d="M9.19295 10.403H3.59626C3.21732 10.403 2.90977 10.0955 2.90977 9.71652C2.90977 9.33757 3.21732 9.03003 3.59626 9.03003H9.19295C9.57189 9.03003 9.87944 9.33757 9.87944 9.71652C9.87944 10.0955 9.57189 10.403 9.19295 10.403Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
			<Path
				d="M7.68222 13.3266H4.9976C4.61866 13.3266 4.31111 13.019 4.31111 12.6401C4.31111 12.2612 4.61866 11.9536 4.9976 11.9536H7.68222C8.06116 11.9536 8.3687 12.2612 8.3687 12.6401C8.3687 13.019 8.06116 13.3266 7.68222 13.3266Z"
				fill="#FFFB0A"
				stroke="transparent"
			/>
		</>
	),
});
